// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/detail/detail_mixins.scss
// module id = 93
// module chunks = 0